'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _RequestStatusTypes = require('conversations-schema/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _immutable.Record)({
  messagesFetchStatus: _RequestStatusTypes2.default.UNINITIALIZED,
  conversationsFetchStatus: _RequestStatusTypes2.default.UNINITIALIZED,
  messageUpdateStatus: _RequestStatusTypes2.default.UNINITIALIZED,
  userSettingsFetchStatus: _RequestStatusTypes2.default.UNINITIALIZED,
  userSettingsUpdateStatus: _RequestStatusTypes2.default.UNINITIALIZED,
  portalSettingsFetchStatus: _RequestStatusTypes2.default.UNINITIALIZED,
  portalSettingsUpdateStatus: _RequestStatusTypes2.default.UNINITIALIZED,
  sendVisitorEmailAddressStatus: _RequestStatusTypes2.default.UNINITIALIZED,
  fetchContactStatus: _RequestStatusTypes2.default.UNINITIALIZED,
  usersFetchStatus: _RequestStatusTypes2.default.UNINITIALIZED,
  teamsFetchStatus: _RequestStatusTypes2.default.UNINITIALIZED,
  meetingsLinksFetchStatus: _RequestStatusTypes2.default.UNINITIALIZED,
  snippetsFetchStatus: _RequestStatusTypes2.default.UNINITIALIZED,
  smartListsFetchStatus: _RequestStatusTypes2.default.UNINITIALIZED,
  widgetData: _RequestStatusTypes2.default.UNINITIALIZED,
  blockVisitorFetchStatus: _RequestStatusTypes2.default.UNINITIALIZED,
  blockVisitorStatus: _RequestStatusTypes2.default.UNINITIALIZED,
  blockedVisitorDeleteStatus: _RequestStatusTypes2.default.UNINITIALIZED,
  serverTimeOffsetStatus: _RequestStatusTypes2.default.UNINITIALIZED,
  chatHistoryFetchStatus: (0, _immutable.Map)()
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/data/records/RequestStatus.js
// module id = 117
// module chunks = 0 1